import { cn } from "@/utils/cn";
import { forwardRef } from "react";
import GradientBar from "../components/GradientBar";

interface NavShellProps {
  dark: boolean;
  sticky?: boolean;
  className?: string;
  /** Slot rendered above the gradient bar (e.g. SaleBanner) */
  banner?: React.ReactNode;
  children: React.ReactNode;
}

/** Structural `<nav>` wrapper — gradient bar + centered max-width container. */
const NavShell = forwardRef<HTMLDivElement, NavShellProps>(
  ({ sticky = true, dark, className, banner, children }, ref) => {
    return (
      <nav
        ref={ref}
        id="navbar"
        data-nav
        className={cn(
          "relative z-50 w-full",
          sticky && "fixed top-0",
          dark && "dark",
          className,
        )}
      >
        {banner}
        <GradientBar />
        <div
          className={cn(
            "px-4 py-3.5 backdrop-blur-lg xl:px-0 dark:bg-surface-0/90 dark:text-white",
          )}
        >
          <div
            role="container"
            className="mx-auto flex max-w-7xl items-center justify-between"
          >
            {children}
          </div>
        </div>
      </nav>
    );
  },
);

NavShell.displayName = "NavShell";

export { NavShell };
